import { render, staticRenderFns } from "./DowngradeInfo.vue?vue&type=template&id=dce70cf4&scoped=true&"
import script from "./DowngradeInfo.vue?vue&type=script&lang=js&"
export * from "./DowngradeInfo.vue?vue&type=script&lang=js&"
import style0 from "./DowngradeInfo.vue?vue&type=style&index=0&id=dce70cf4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce70cf4",
  null
  
)

export default component.exports